import {combineReducers} from 'redux';
import translations from './translations';
import auth from './auth';

export default combineReducers({
    translations,
    auth
});
